// src/components/ResultsExport.jsx
// Buttons to take the final ranking with you: a spreadsheet (CSV), or a picture, shared through the phone's share sheet
// where there is one, else saved.
import React, { useState } from 'react';
import { useToast } from './Toast';
import { DownloadIcon } from './icons';
import { canvasToBlob, downloadBlob, drawRanking, fileNameFor, rankingToCsv } from '../utils/resultsExport';

function ResultsExport({ name, dates, standings, ranking }) {
    const toast = useToast();
    const [busy, setBusy] = useState(false);

    const saveCsv = () => {
        downloadBlob(new Blob([rankingToCsv(standings, ranking || undefined)], { type: 'text/csv;charset=utf-8' }), fileNameFor(name, 'csv'));
    };

    const saveImage = async () => {
        setBusy(true);
        try {
            const canvas = drawRanking(document.createElement('canvas'), { name, dates, standings, ranking: ranking || undefined });
            const blob = await canvasToBlob(canvas);
            if (!blob) throw new Error('no picture');
            const file = new File([blob], fileNameFor(name, 'png'), { type: 'image/png' });
            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                try {
                    await navigator.share({ files: [file], title: name });
                } catch (error) {
                    if (error && error.name !== 'AbortError') throw error; // closing the share sheet is fine
                }
            } else {
                downloadBlob(blob, file.name);
            }
        } catch (error) {
            console.error('Could not make the picture:', error);
            toast.error('Could not make the picture.');
        }
        setBusy(false);
    };

    return (
        <div className="results-export">
            <button className="btn" onClick={saveImage} disabled={busy || standings.length === 0}>
                <DownloadIcon size={16} /> Picture
            </button>
            <button className="btn" onClick={saveCsv} disabled={standings.length === 0}>
                <DownloadIcon size={16} /> Spreadsheet (CSV)
            </button>
        </div>
    );
}

export default ResultsExport;
